import { render, staticRenderFns } from "./printTask.vue?vue&type=template&id=66e96505"
import script from "./printTask.vue?vue&type=script&lang=js"
export * from "./printTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports